// Centralized color theme configuration for AIVA Web
// Using consistent blue theme from shadcn v4

const colors = {
  // Primary brand colors
  primary: {
    blue: '#2563eb',
    red: '#EF4444',
  },

  // Neutral colors (grays, whites, blacks)
  neutral: {
    white: '#FFFFFF',
    black: '#000000',
    gray50: '#F9FAFB',
    gray100: '#F3F4F6',
    gray200: '#E5E7EB',
    gray300: '#D1D5DB',
    gray400: '#9CA3AF',
    gray500: '#6B7280',
    gray600: '#4B5563',
    gray700: '#374151',
    gray800: '#1F2937',
    gray900: '#111827',
    // Custom grays
    lightGray: '#F8F8F8',
    darkGray: '#333333',
    slightGray: '#F8F9FA',
  },

  // Background accent colors
  background: {
    lightPurple: '#E8EFFF',
    slightPurple: '#F0F4FF',
    lightBlue: '#E8EFFF',
  },

  // Semantic colors for states
  semantic: {
    success: '#10B981', // emerald-500
    successDark: '#059669', // emerald-600
    error: '#EF4444', // red-500
    errorDark: '#DC2626', // red-600
    errorDarker: '#B91C1C', // red-700
    warning: '#F59E0B', // amber-500
    warningDark: '#D97706', // amber-600
    info: '#2563eb', // primary blue
  },

  // UI component colors - using consistent blue theme
  ui: {
    // Blues for various UI elements
    blueLight: '#DBEAFE',
    blueMedium: '#1D4ED8',
    blueChat: '#2563eb',
    blueChatDark: '#1D4ED8',
    
    // Additional UI colors
    purple: '#8B5CF6', // purple-500
    purpleDark: '#7C3AED', // purple-600
    indigo: '#6366F1', // indigo-500
    indigoDark: '#4F46E5', // indigo-600
    pink: '#EC4899', // pink-500
    pinkDark: '#DB2777', // pink-600
    orange: '#F97316', // orange-500
    orangeDark: '#EA580C', // orange-600
    orangeCustom: '#EA8600',
    cyan: '#06B6D4', // cyan-500
    teal: '#14B8A6', // teal-500
    lime: '#84CC16', // lime-500
  },

  // Social/brand colors
  social: {
    google: '#4285F4',
    googleAlt: '#1A73E8',
    googleRed: '#EA4335',
    outlook: '#0078D4',
    apple: '#000000',
  },

  // Label colors for notes feature
  labels: {
    personal: { bg: '#DBEAFE', text: '#3730A3' },
    work: { bg: '#FCE7F3', text: '#BE185D' },
    ideas: { bg: '#FEF3C7', text: '#D97706' },
    important: { bg: '#FBCFE8', text: '#BE185D' },
    study: { bg: '#D1FAE5', text: '#059669' },
    research: { bg: '#E0E7FF', text: '#4F46E5' },
    creative: { bg: '#FED7AA', text: '#EA580C' },
    archive: { bg: '#A7F3D0', text: '#059669' },
    projects: { bg: '#C7D2FE', text: '#6366F1' },
    finance: { bg: '#BFDBFE', text: '#2563EB' },
    health: { bg: '#FDE68A', text: '#D97706' },
    shopping: { bg: '#FDBA74', text: '#EA580C' },
  },

  // Project colors
  projects: [
    { name: 'Blue', value: '#2563eb' },
    { name: 'Green', value: '#10B981' },
    { name: 'Yellow', value: '#F59E0B' },
    { name: 'Red', value: '#EF4444' },
    { name: 'Purple', value: '#8B5CF6' },
    { name: 'Pink', value: '#EC4899' },
    { name: 'Indigo', value: '#6366F1' },
    { name: 'Teal', value: '#14B8A6' },
    { name: 'Orange', value: '#F97316' },
    { name: 'Cyan', value: '#06B6D4' },
  ],

  // Calendar integration colors
  calendar: {
    google: '#4285F4',
    outlook: '#0078D4',
    apple: '#000000',
    other: '#84CC16',
  },
  
  // Dark mode specific colors for consistency
  dark: {
    bg: '#0f1117', // Main dark background
    bgSecondary: '#1a1d26', // Secondary dark background (cards, modals)
    bgTertiary: '#242832', // Tertiary dark background (hover states)
    bgModal: '#1a1d26', // Modal backgrounds
    bgInput: '#242832', // Input field backgrounds
    border: '#2d3039', // Dark mode borders
    borderLight: '#383c47', // Lighter borders for hover
    text: '#e5e7eb', // Primary text color in dark mode
    textSecondary: '#9ca3af', // Secondary text color
    textMuted: '#6b7280', // Muted text color
  },
};

// Export for CommonJS (used by tailwind.config.js)
module.exports = colors;